export default {
  'registration.registration': 'ĐĂNG KÝ',
}
